<template>
  <div class="page-container">
    <Toast ref="toast" />
    <div class="page-title-container">
      <h1 class="title-text">Lead Recruiter</h1>
      <h2 class="subtitle-text">Remote - $80,000/year</h2>
    </div>

    <div class="center-items">
      <div class="form-container">
        <div style="margin-bottom: 1.5rem;">
          <p class="form-title-text">UPLOAD YOUR CV*</p>

          <input ref="cv" accept=".pdf" type="file" @change="filePreview($refs.cv)" />

          <div style="margin-top: 1.5rem;">
            <input
              class="input-container input-conatiner-medium"
              placeholder="Enter your email"
              ref="email"
              id="email"
              name="email"
              v-model="email"
              @click="select($refs.email, email)"
              type="text"
              @keyup.enter="subscribe()"
              maxlength="1000"
            />
            <button type="button" @click="subscribe" class="primary-button">Apply</button>
          </div>
          <p>
            <input type="checkbox" v-model="isChecked" style="cursor:pointer" class="checkbox_subscribe_to_remoteok" />
            Check this to receive job offers, marketing email and content from Jobboardy
          </p>

          <p v-if="showNotValidEmail" class="p-error">⚠️ Email not looking correct, try with the following format: name@domain.com</p>
          <p v-if="alreadyUsed" class="p-error">⚠️ Email already subscribed</p>
          <p v-if="serverError" class="p-error">⚠️ Server error, please contact the devs</p>
          <p v-if="noFileError" class="p-error">⚠️ Please add your CV in .pdf format.</p>
        </div>
      </div>
    </div>

    <div class="center-items">
      <div class="article-container">
        <article>
          <h3>Summary</h3>
          <p>
            <a>JobBoardy</a> is the perfect tool for recruiters. Our SaaS allows you to send job offers to a large selection of
            niche-specific job boards in under 2 minutes, saving your team’s precious time.
          </p>
          <p>
            Automatize your job offer delivery to every major or minor site, also we allow you to discover new niche sites to find top
            quality candidates for your position. Join our mission to create the best tools for recruiters.
          </p>

          <h3>What you will be doing</h3>
          <p>
            The Technical Recruiter role works closely with colleagues on the People and leadership teams to build a world class talent
            acquisition initiatives at JobBoardy. This includes creating and updating processes and strategies to help us scale as we
            continue our worldwide growth, and to increase consistencies, effectiveness and efficiencies company-wide.
          </p>
          <p>
            Focusing on hiring for talent, regardless of location, selecting people who live Jobboardy’s values, modeling the behaviors that
            fit our culture with the skills and competencies needed to do the job is a critical component for the successful evolution of
            our culture.
          </p>
          <p>
            We are looking for someone who thrives in an autonomous, innovative, fast-paced setting. They will develop processes, juggle
            multiple and sometimes changing priorities and work well with remote team members, hiring managers and candidates in different
            countries and time zones.
          </p>

          <h3>Lead Recruiter Key Responsibilities</h3>
          <p>&bull; Manage candidate experience through screening, interview, offer, start and onboarding.</p>
          <p>
            &bull; Develop, streamline and roll-out processes for end-to-end candidate experience including sourcing, screening,
            interviewing, selection & onboarding
          </p>
          <p>&bull; Partner with multiple stakeholders on headcount management & approvals.</p>
          <p>&bull; Report and analyze recruiting data and trends monthly.</p>
          <p>&bull; Recommend ideas and recruiting strategies to proactively meet Jobboardy’s growth initiatives.</p>
          <p>&bull; Manage applicant tracking system data.</p>
          <p>&bull; Post jobs to external websites.</p>
          <p>&bull; Train new hiring managers on interview techniques, hiring processes and using our Applicant Tracking System.</p>
          <p>&bull; Participate in regional hiring events and meet-ups as needed.</p>

          <h3>Basic Requirements</h3>
          <p>&bull; Participate in regional hiring events and meet-ups as needed.</p>
          <p>&bull; Degree in HR, Business, psychology, communications, or a related field.</p>
          <p>&bull; Solid knowledge of general HR best practices (e.g. recruiting, training, compensation / benefits).</p>
          <p>&bull; Demonstrated expertise in talent selection / assessment skills.</p>
          <p>&bull; Experience building processes & systems including using technology to be most efficient.</p>
          <p>&bull; Able to work well independently in an ambiguous environment.</p>
          <p>&bull; Proficiency in Office, Mail and other online tools.</p>
          <p>
            &bull; Passion for sourcing passive candidates and tough to fill roles; experience working with agency recruiters and/or
            previous experience as an agency recruiter is a plus.
          </p>
          <p>&bull; Savvy to balance & prioritize multiple projects, clients and candidates.</p>
          <p>&bull; Strong communication, organizational and negotiation skills.</p>

          <h3>Nice to have Requirements</h3>
          <p>&bull; International recruiting experience.</p>
          <p>&bull; Experience working in a global software company is a plus.</p>
          <p>&bull; Experience with teams of more than 5 people.</p>
          <p>&bull; Experience creating top-notch teams.</p>

          <h3>Apply here</h3>
          <p>There is so much to cover for this exciting role, and space here is limited.</p>
          <p>
            Upload your CV and hit the Apply button if you found this interesting and want to learn more. We look forward to meeting you!
          </p>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import * as validator from "email-validator";
import firebase from "@/firebase";
import Toast from "@/components/Toast";

export default {
  components: {
    Toast,
  },

  data() {
    return {
      file: "",
      showNotValidEmail: false,
      alreadyUsed: false,
      serverError: false,
      noFileError: false,
      email: "",
      isChecked: true,
      list: "6c4393b4-5bd3-11eb-a3d0-06b4694bee2a", // jobboardy-our-jobs
      notAcceptedList: "fbe1f050-5c9e-11eb-a3d0-06b4694bee2a", // jobboardy-our-jobs-not-checked
    };
  },

  created() {
    window.scrollTo(0, 0);
  },

  methods: {
    filePreview(ref) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.file = e.target.result;
      };

      const file = ref.files[0];

      if (!file) {
        this.file = "";
        return;
      }

      reader.readAsDataURL(file);
    },

    select(ref, model) {
      ref.focus();
      ref.setSelectionRange(0, model.length);
    },

    async subscribe() {
      this.alreadyUsed = false;
      this.showNotValidEmail = false;
      this.serverError = false;
      this.noFileError = false;

      if (!validator.validate(this.email)) {
        this.showNotValidEmail = true;
        return;
      }

      if (this.file === "") {
        this.noFileError = true;
        return;
      }

      try {
        const metadata = {
          contentType: "application/pdf",
        };
        const d = new Date().getTime().toString();
        const imagePath = "/our-jobs/" + d + ".pdf";
        const ref = firebase.storage.ref().child(imagePath);
        await ref.putString(this.file, "data_url", metadata);
      } catch (e) {
        console.error(e);
        this.noFileError = true;
        this.email = "";
        return;
      }

      try {
        if (this.isChecked) {
          await firebase.functions.httpsCallable("addSubscriber")({ email: this.email, list: this.list });
        } else {
          await firebase.functions.httpsCallable("addSubscriber")({ email: this.email, list: this.notAcceptedList });
        }
      } catch (e) {
        if (e.code === "aborted") {
          this.alreadyUsed = true;
          this.email = "";
          return;
        }
        this.serverError = true;
        this.email = "";
        console.error(e);
      }

      this.email = "";
      this.$refs.toast.text = "Thanks for your application!";
      this.$refs.toast.show();
    },
  },
};
</script>

<style></style>
